import { useState } from 'react'
import { useLocale } from '../App'

const getStr = (c: Record<string, unknown>, key: string, def: string) => (c[key] as string | undefined) ?? def

export function ContactPage() {
  const { content: c } = useLocale()
  const cx = c as Record<string, unknown>
  const [sent, setSent] = useState(false)
  const title = getStr(cx, 'contactTitle', '联系我们')
  const subtitle = getStr(cx, 'contactSubtitle', '我们随时为您解答疑问，欢迎咨询')
  const contactTitle = getStr(cx, 'contactInfoTitle', '联系方式')
  const formTitle = getStr(cx, 'contactFormTitle', '发送消息')
  const formDesc = getStr(cx, 'contactFormDesc', '填写下方表单，我们将在24小时内回复您')
  const contactItems = (cx.contactItems as { icon: string; title: string; content?: string; social?: boolean }[] | undefined) ?? [
    { icon: 'fa-envelope', title: '邮箱', content: 'support@equinerwa.com\nbusiness@equinerwa.com' },
    { icon: 'fa-map-marker-alt', title: '地址', content: '2 Orchard Turn, #05-03 ION Orchard\nSingapore 238801' },
    { icon: 'fa-comments', title: '社交媒体', social: true },
  ]
  const subjectOptions = (cx.contactSubjectOptions as { value: string; label: string }[] | undefined) ?? [
    { value: '', label: '请选择咨询主题' },
    { value: 'general', label: '一般咨询' },
    { value: 'investment', label: '投资相关' },
    { value: 'technical', label: '技术支持' },
    { value: 'partnership', label: '合作洽谈' },
    { value: 'media', label: '媒体采访' },
    { value: 'other', label: '其他' },
  ]

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setSent(true)
  }

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="header-content">
            <h1 className="page-title">{title}</h1>
            <p className="page-subtitle">{subtitle}</p>
          </div>
        </div>
      </section>

      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info-card">
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--color-secondary)', marginBottom: '2rem' }}>{contactTitle}</h2>
              {contactItems.map((item: { icon: string; title: string; content?: string; social?: boolean }, i: number) => (
                <div key={i} className="contact-item">
                  <div className="contact-icon">
                    <i className={`fas ${item.icon}`}></i>
                  </div>
                  <div className="contact-details">
                    <h3>{item.title}</h3>
                    {item.social ? (
                      <div style={{ display: 'flex', gap: '1rem', marginTop: '0.75rem' }}>
                        <a href="#" style={{ color: 'var(--color-primary)', fontSize: '1.5rem' }}><i className="fab fa-twitter"></i></a>
                        <a href="#" style={{ color: 'var(--color-primary)', fontSize: '1.5rem' }}><i className="fab fa-telegram"></i></a>
                        <a href="#" style={{ color: 'var(--color-primary)', fontSize: '1.5rem' }}><i className="fab fa-discord"></i></a>
                        <a href="#" style={{ color: 'var(--color-primary)', fontSize: '1.5rem' }}><i className="fab fa-medium"></i></a>
                      </div>
                    ) : (
                      <p style={{ whiteSpace: 'pre-line' }}>{item.content}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="contact-form-card">
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', color: 'var(--color-secondary)', marginBottom: '1rem' }}>{formTitle}</h2>
              <p style={{ color: 'var(--color-gray-600)', marginBottom: '2rem' }}>{formDesc}</p>
              {sent ? (
                <p style={{ padding: '2rem', background: 'var(--color-background)', borderRadius: 'var(--radius-lg)', color: 'var(--color-accent)', fontWeight: 600 }}>
                  {getStr(cx, 'contactThankYou', '感谢您的消息！我们将在24小时内回复您。')}
                </p>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="contact-form-card" style={{ boxShadow: 'none', padding: 0 }}>
                    <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                      <label htmlFor="contact-name">{getStr(cx, 'contactName', '姓名')} *</label>
                      <input type="text" id="contact-name" name="name" required placeholder={getStr(cx, 'contactNamePlaceholder', '请输入您的姓名')} />
                    </div>
                    <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                      <label htmlFor="contact-email">{getStr(cx, 'contactEmail', '邮箱')} *</label>
                      <input type="email" id="contact-email" name="email" required placeholder="your@email.com" />
                    </div>
                    <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                      <label htmlFor="contact-subject">{getStr(cx, 'contactSubject', '主题')} *</label>
                      <select id="contact-subject" name="subject" required>
                        {subjectOptions.map((opt: { value: string; label: string }, i: number) => (
                          <option key={i} value={opt.value}>{opt.label}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group" style={{ marginBottom: '1.5rem' }}>
                      <label htmlFor="contact-message">{getStr(cx, 'contactMessage', '消息内容')} *</label>
                      <textarea id="contact-message" name="message" required placeholder={getStr(cx, 'contactMessagePlaceholder', '请详细描述您的问题或需求...')} />
                    </div>
                  </div>
                  <button type="submit" className="form-submit">
                    <i className="fas fa-paper-plane"></i> {getStr(cx, 'contactSend', '发送消息')}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="contact-map-section" style={{ padding: 0, height: 400, background: 'var(--color-gray-200)' }}>
        <iframe
          title={getStr(cx, 'contactMapPlaceholder', '地图位置 - 新加坡总部')}
          src="https://www.openstreetmap.org/export/embed.html?bbox=103.828%2C1.302%2C103.836%2C1.308&layer=mapnik&marker=1.3048%2C103.8322"
          width="100%"
          height="100%"
          style={{ border: 0, display: 'block' }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </section>
    </>
  )
}
